import BackToResultButton from 'components/common/BackToResultButton';
import { ButtonContainer } from 'components/credits/credit-details/CreditItemDetailsButtonContainer/components';
import { CreditType } from 'types/credit';
import { SaveButton } from 'components/common/SaveButton';
import { fontStyles } from 'styles/theme';

type Props = {
  creditItemID: string;
  creditType: CreditType;
};

export function CreditItemDetailsButtonContainer(props: Props): JSX.Element {
  const { creditItemID, creditType } = props;
  return (
    <ButtonContainer className='credit-details-button-container'>
      <BackToResultButton color={fontStyles.colors.tertiary} />
      <SaveButton creditItemID={creditItemID} creditType={creditType} />
    </ButtonContainer>
  );
}
